// Returns the slug of an str
export default function (str) {
  if (!str) return "";
  return str
    .toLowerCase()
    .replace(/ /g, "-")
    .replace(/[^\w]+/g, "");
}
